// Offer Card Header Component
// Displays the header section of an offer card with title, subtitle, and price

import { OFFERS } from "./offers-config.ts";

class OfferCardHeader extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    const offerId = this.getAttribute("offer-id");
    const gradient = this.getAttribute("gradient") || "from-blue-500 to-blue-600";
    const primary = this.getAttribute("primary") || "blue-600";

    if (!offerId) {
      console.error("OfferCardHeader: offer-id attribute is required");
      return;
    }

    const offer = OFFERS.find((o) => o.id === offerId);
    if (!offer) {
      console.error(`OfferCardHeader: offer with id "${offerId}" not found`);
      return;
    }

    const priceDisplay = typeof offer.price === "number" ? `€${offer.price}` : offer.price;
    const baseColor = primary.split("-")[0]; // Extract base color (e.g., "blue" from "blue-600")

    this.innerHTML = `
      <div class="bg-gradient-to-br ${gradient} p-8 text-white">
        <h3 class="text-5xl font-bold mb-4">
          <span data-en="${offer.title.en}" data-lv="${offer.title.lv}" data-it="${offer.title.it}">
            ${offer.title.en}
          </span>
        </h3>
        <p class="text-${baseColor}-100 text-lg">
          <span data-en="${offer.subtitle.en}" data-lv="${offer.subtitle.lv}" data-it="${offer.subtitle.it}">
            ${offer.subtitle.en}
          </span>
        </p>
      </div>
    `;
  }
}

customElements.define("offer-card-header", OfferCardHeader);

export { OfferCardHeader };

